"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Observable } from 'rxjs/Observable';
import { catchError, filter, map, switchMap, take, tap, withLatestFrom, } from 'rxjs/operators';
import { backend, deletePayload, pushPayload, setPayload, updatePayload, } from './backend';
import { assertNever, isDefined, } from './helpers';
var ListObservable = /** @class */ (function (_super) {
    __extends(ListObservable, _super);
    function ListObservable(ref$, apiHttp, auth, store, errorTracking, source) {
        var _this = _super.call(this) || this;
        _this.ref$ = ref$;
        _this.apiHttp = apiHttp;
        _this.auth = auth;
        _this.store = store;
        _this.errorTracking = errorTracking;
        _this.source = source;
        return _this;
    }
    ListObservable.prototype.lift = function (operator) {
        var observable = new ListObservable(this.ref$, this.apiHttp, this.auth, this.store, this.errorTracking, this);
        observable.operator = operator;
        return observable;
    };
    ListObservable.prototype.push = function (object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) {
            var path = ref.path, query = ref.query;
            var payload = pushPayload(ref, object, _this.errorTracking);
            if (!payload) {
                return Observable.of(false);
            }
            return Observable.of(backend[path[0]].post).pipe(filter(isDefined), map(function (post) { return post(path[1], object); }), tap(function (data) {
                // FIXME: T37425 Works in TS 2.5
                // const action: ActionType<T> = { type: `API_PUSH`, payload };
                var action = { type: "API_PUSH", payload: payload };
                _this.store.dispatch(action);
            }), switchMap(function (config) { return _this.apiHttp.post(config, payload.rawRequest); }), catchError(function (data) {
                _this.sendActions({ type: 'PUSH', payload: payload }, path, query, data);
                return Observable.throw(data);
            }), map(function (data) {
                return _this.sendActions({ type: 'PUSH', payload: payload }, path, query, data);
            }));
        }))
            .toPromise();
    };
    ListObservable.prototype.set = function (id, object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) {
            var path = ref.path, query = ref.query;
            return Observable.of(backend[path[0]].post).pipe(filter(isDefined), map(function (post) { return post(path[1], object); }), withLatestFrom(_this.store), map(function (_a) {
                var config = _a[0], store = _a[1];
                return ({
                    config: config,
                    payload: setPayload(ref, id, object, store, _this.errorTracking),
                });
            }), filter(isPayloadDefined), tap(function (_a) {
                var payload = _a.payload;
                // FIXME: T37425 Works in TS 2.5
                // const action: ActionType<T> = { type: `API_SET`, payload };
                var action = { type: "API_SET", payload: payload };
                _this.store.dispatch(action);
            }), switchMap(function (_a) {
                var config = _a.config, payload = _a.payload;
                return _this.apiHttp.post(config, payload.rawRequest);
            }, function (_a, data) {
                var payload = _a.payload;
                return ({ payload: payload, data: data });
            }), map(function (_a) {
                var payload = _a.payload, data = _a.data;
                return _this.sendActions({ type: 'SET', payload: payload }, path, query, data);
            }));
        }))
            .toPromise();
    };
    ListObservable.prototype.update = function (id, object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), withLatestFrom(this.store), map(function (_a) {
            var ref = _a[0], store = _a[1];
            return updatePayload(ref, id, object, store, _this.errorTracking);
        }), filter(isDefined), tap(function (_a) {
            var payload = _a.payload;
            // FIXME: T37425 Works in TS 2.5
            // const action: ActionType<T> = { type: `API_SET`, payload };
            var action = { type: "API_UPDATE", payload: payload };
            _this.store.dispatch(action);
        }), switchMap(function (_a) {
            var endpoint = _a.endpoint, payload = _a.payload, method = _a.method;
            switch (method) {
                case 'POST':
                    return _this.apiHttp.post({ endpoint: endpoint, params: {} }, payload.rawRequest);
                case 'PUT':
                    return _this.apiHttp.put({ endpoint: endpoint, params: {} }, payload.rawRequest);
                default:
                    return assertNever(method);
            }
        }, function (_a, data) {
            var payload = _a.payload;
            return ({ payload: payload, data: data });
        }), map(function (_a) {
            var payload = _a.payload, data = _a.data;
            return _this.sendActions({ type: 'UPDATE', payload: payload }, payload.ref.path, payload.ref.query, data);
        }))
            .toPromise();
    };
    ListObservable.prototype.remove = function (id) {
        var _this = this;
        return this.ref$
            .pipe(take(1), withLatestFrom(this.store), map(function (_a) {
            var ref = _a[0], store = _a[1];
            return deletePayload(ref, id, store, _this.errorTracking);
        }), filter(isDefined), tap(function (_a) {
            var payload = _a.payload;
            // FIXME: T37425 Works in TS 2.5
            // const action: ActionType<T> = { type: `API_SET`, payload };
            var action = { type: "API_DELETE", payload: payload };
            _this.store.dispatch(action);
        }), switchMap(function (_a) {
            var endpoint = _a.endpoint, payload = _a.payload, method = _a.method;
            switch (method) {
                case 'POST':
                    return _this.apiHttp.post({ endpoint: endpoint, params: {} }, payload.rawRequest);
                case 'PUT':
                    return _this.apiHttp.put({ endpoint: endpoint, params: {} }, payload.rawRequest);
                case 'DELETE':
                    return _this.apiHttp.delete({ endpoint: endpoint, params: {} });
                default:
                    return assertNever(method);
            }
        }, function (_a, data) {
            var payload = _a.payload;
            return ({ payload: payload, data: data });
        }), map(function (_a) {
            var payload = _a.payload, data = _a.data;
            return _this.sendActions({ type: 'DELETE', payload: payload }, payload.ref.path, payload.ref.query, data);
        }))
            .toPromise();
    };
    ListObservable.prototype.sendActions = function (baseAction, path, query, data) {
        switch (data.status) {
            case 'success': {
                var action = baseAction.type === 'PUSH'
                    ? {
                        type: 'API_PUSH_SUCCESS',
                        payload: __assign({}, baseAction.payload, { result: data.result }),
                    }
                    : baseAction.type === 'SET'
                        ? {
                            type: 'API_SET_SUCCESS',
                            payload: __assign({}, baseAction.payload, { result: data.result }),
                        }
                        : baseAction.type === 'UPDATE'
                            ? {
                                type: 'API_UPDATE_SUCCESS',
                                payload: __assign({}, baseAction.payload, { result: data.result }),
                            }
                            : {
                                type: 'API_DELETE_SUCCESS',
                                payload: __assign({}, baseAction.payload, { result: data.result }),
                            };
                this.store.dispatch(action);
                return true;
            }
            case 'error': {
                var action = baseAction.type === 'PUSH'
                    ? {
                        type: 'API_PUSH_ERROR',
                        payload: __assign({}, baseAction.payload, { message: data.message }),
                    }
                    : baseAction.type === 'SET'
                        ? {
                            type: 'API_SET_ERROR',
                            payload: __assign({}, baseAction.payload, { message: data.message }),
                        }
                        : baseAction.type === 'UPDATE'
                            ? {
                                type: 'API_UPDATE_ERROR',
                                payload: __assign({}, baseAction.payload, { message: data.message }),
                            }
                            : {
                                type: 'API_DELETE_ERROR',
                                payload: __assign({}, baseAction.payload, { message: data.message }),
                            };
                this.store.dispatch(action);
                console.log(action.payload.type, data.message, path, query);
                return false;
            }
            default: {
                var action = baseAction.type === 'PUSH'
                    ? {
                        type: 'API_PUSH_ERROR',
                        payload: __assign({}, baseAction.payload, { message: 'Unexpected API response', error: data }),
                    }
                    : baseAction.type === 'SET'
                        ? {
                            type: 'API_SET_ERROR',
                            payload: __assign({}, baseAction.payload, { message: 'Unexpected API response' }),
                        }
                        : baseAction.type === 'UPDATE'
                            ? {
                                type: 'API_UPDATE_ERROR',
                                payload: __assign({}, baseAction.payload, { message: 'Unexpected API response' }),
                            }
                            : {
                                type: 'API_DELETE_ERROR',
                                payload: __assign({}, baseAction.payload, { message: 'Unexpected API response' }),
                            };
                this.store.dispatch(action);
                return false;
            }
        }
    };
    return ListObservable;
}(Observable));
export { ListObservable };
function isPayloadDefined(x) {
    return x.payload !== undefined;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/list-observable.ts.pre-build-optimizer.js